import React from 'react'
import './loading.css'

const Loading = props => {
    const style = {
        fontSize: size(props.size),
        color: props.color
    }
    return (
        <div className='main-loader'>
            <div className='loader' style={style} />
        </div>
    )
}

const size = s => {
    if(!s) return '10px'
    else {

        switch (s) {
            case 'small':
                return '5px'
            case 'medium':
                return '10px'
            case 'large':
                return '15px'
            default:
                return s
        }
    }

}

export default Loading